import "./index.scss";

import React, { useState } from "react";

import { useSnackbar } from "notistack";

import { withdrawFundsAPI } from "../../../api";

import { useStore } from "../../../store";

import WithdrawPopupView from "./view";

import { CURRENCIES } from "./const";

const WithdrawPopupController = ({ close }) => {
  // mode: initial | confirm
  const [mode, setMode] = useState("initial");

  const [isLoading, setIsLoading] = useState(false);
  const [requestData, setRequestData] = useState({
    amount: 0,
    wallet_address: "",
  });
  const [withdrawCurrency, setWithdrawCurrency] = useState(CURRENCIES.usdt);

  const { enqueueSnackbar } = useSnackbar();

  const { user, getMe } = useStore();

  const maxAmount =
    withdrawCurrency === CURRENCIES.usdt
      ? user.balance
      : withdrawCurrency === CURRENCIES.C4
      ? user.c_four_balance
      : 100;

  const handleSaveRequestData = (e) => {
    e.preventDefault();

    const amount = e.target.amount.value;
    const walletAddress = e.target.walletAddress.value;
    setRequestData({
      wallet_address: walletAddress,
      amount: Number(amount),
      currency:
        withdrawCurrency === CURRENCIES.usdt
          ? "USDT"
          : withdrawCurrency === CURRENCIES.C4
          ? "C4"
          : undefined,
    });
    setMode("confirm");
  };

  const handleSubmit = () => {
    if (requestData.address === "") {
      return;
    }

    setIsLoading(true);
    withdrawFundsAPI(requestData)
      .then(() => {
        enqueueSnackbar("Withdrawal was successful", { variant: "success" });
        close();
        getMe();
      })
      .catch((error) => {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <WithdrawPopupView
      close={close}
      isLoading={isLoading}
      mode={mode}
      withdrawCurrency={withdrawCurrency}
      setWithdrawCurrency={setWithdrawCurrency}
      setMode={setMode}
      handleSaveRequestData={handleSaveRequestData}
      handleSubmit={handleSubmit}
      requestData={requestData}
      maxAmount={maxAmount}
    />
  );
};

export default WithdrawPopupController;
